/**
 * ユーザー詳細ダイアログ専用i18n定数
 */

export const USER_DETAILS_I18N = {
  // 性別オプション
  sex: {
    male: $localize`:@@admin.userDetails.sex.male:男性`,
    female: $localize`:@@admin.userDetails.sex.female:女性`,
    other: $localize`:@@admin.userDetails.sex.other:その他`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.userDetails.status.active:有効`,
    inactive: $localize`:@@admin.userDetails.status.inactive:無効`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.userDetails.button.close:閉じる`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@admin.userDetails.message.updateSuccess:更新が完了しました。`,
    updateError: $localize`:@@admin.userDetails.message.updateError:更新に失敗しました。再度お試しください。`,
    userUpdateSuccess: $localize`:@@admin.userDetails.message.userUpdateSuccess:ユーザーの情報を更新しました。`,
    userUpdateError: $localize`:@@admin.userDetails.message.userUpdateError:ユーザーの情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },
} as const;

export type UserDetailsI18n = typeof USER_DETAILS_I18N;
